import { useState } from 'react'

interface Props {
  label: string
  value: string | null | undefined
  /** Пароль скрыт точками, пока его не показали. */
  secret?: boolean
}

/**
 * Строка реквизита доступа. Кнопки «копировать» у каждого поля нет: значение
 * выделяется одним щелчком (user-select: all в стилях), дальше Ctrl+C или
 * правая кнопка мыши. Всю запись целиком копирует кнопка внизу карточки.
 */
export default function CopyField({ label, value, secret = false }: Props) {
  const [shown, setShown] = useState(!secret)

  if (!value) return null

  return (
    <div className="copy-field">
      <span className="copy-label">{label}</span>
      <span className="copy-value mono">{shown ? value : '••••••••'}</span>
      {secret && (
        <button type="button" className="btn small" onClick={() => setShown(!shown)}>
          {shown ? 'Скрыть' : 'Показать'}
        </button>
      )}
    </div>
  )
}

/** Собирает запись доступа в текст для копирования одной кнопкой. */
export function buildAccessText(lines: [string, string | null | undefined][]): string {
  return lines
    .filter(([, v]) => v)
    .map(([k, v]) => `${k}: ${v}`)
    .join('\n')
}

/** Кнопка «Копировать всё» с запасным вариантом для незащищённого контекста. */
export function CopyAllButton({ text, label = 'Копировать' }: { text: string; label?: string }) {
  const [state, setState] = useState<'idle' | 'ok' | 'fail'>('idle')

  async function copy() {
    try {
      await navigator.clipboard.writeText(text)
      setState('ok')
    } catch {
      // clipboard недоступен по http — кладём во временное поле и копируем командой
      const area = document.createElement('textarea')
      area.value = text
      area.style.position = 'fixed'
      area.style.opacity = '0'
      document.body.appendChild(area)
      area.select()
      const ok = document.execCommand('copy')
      area.remove()
      setState(ok ? 'ok' : 'fail')
    }
    setTimeout(() => setState('idle'), 2000)
  }

  return (
    <button type="button" className="btn" onClick={copy}>
      {state === 'ok' ? '✓ Скопировано' : state === 'fail' ? 'Выделите вручную' : label}
    </button>
  )
}
